import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Form, notification, Row, Col, Button, Modal, Typography, Upload, Spin, message, Select } from 'antd';
import config from '../../config';
import * as userActions from '../../redux/actions/userActions';
import {
  confirmationModal,
  formItemLayout,
  tailFormItemLayout,
  showFilesList,
  showUploadFileList,
  unexpectedError,
  beforeUpload,
} from '../../common_functions';
import UploadTrigger from '../../common_functions/UploadTrigger';
import UploadedCheck from '../../common_functions/UploadedCheck';

const MicroMeter = props => {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [microData, setMicroData] = useState(false);
  const [title, setTitle] = useState('Add Glossmeter');
  const [printData, setPrintData] = useState(false);
  const [mountingData, setMountingData] = useState([]);
  const [filesState, setFilesState] = useState({
    photo: [],
    mount: [],
    bag: [],
  });
  let error = [];
  let saveAndNext = '';

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const { data: mountData } = await dispatch(
          userActions.getItems('mounting_methods', {
            fields: ['id', 'methods'],
            limit: -1,
          })
        );
        setMountingData(mountData);
        const {
          data: { c_print, micrometer, glossmeter, collection_id, mounting_method },
        } = await dispatch(
          userActions.getItem('print', props.print, {
            fields: [
              'c_print.acquisition,c_print.title,micrometer.*,micrometer.mount.id,micrometer.mount.filename_download,micrometer.bag.id,micrometer.bag.filename_download,micrometer.photo.id,micrometer.photo.filename_download,glossmeter.id,collection_id.name,mounting_method',
            ],
          })
        );
        setPrintData({
          acquisition: c_print?.[0]?.['acquisition'],
          title: c_print?.[0]?.['title'],
          name: collection_id?.name,
        });
        if (micrometer?.length > 0) {
          const [micrometerData] = micrometer;
          setFilesState({
            photo: showUploadFileList(micrometerData?.photo?.id, micrometerData?.photo?.filename_download),
            mount: showUploadFileList(micrometerData?.mount?.id, micrometerData?.mount?.filename_download),
            bag: showUploadFileList(micrometerData?.bag?.id, micrometerData?.bag?.filename_download),
          });
          micrometerData.mount = micrometerData?.mount?.id;
          micrometerData.bag = micrometerData?.bag?.id;
          micrometerData.photo = micrometerData?.photo?.id;

          formRef.current.setFieldsValue({
            ...micrometerData,
          });
          setMicroData(micrometerData);
        }
        if (glossmeter?.length > 0) {
          setTitle('Edit Glossmeter');
        }
        formRef.current.setFieldsValue({ mounting_method });
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    //   fetchData();
    // }, [props.print, props.mountingUpdate]);
    if (props.activeTab === 'micrometer') {
      formRef.current?.setFields([
        {
          name: 'micrometer',
          errors: [],
        },
      ]);
      fetchData();
    }
  }, [props.activeTab]);

  const complete = async values => {
    Modal.destroyAll();
    values = { ...values, object_status: 1 };
    await onSave(values);
  };
  const incomplete = async values => {
    Modal.destroyAll();
    values = { ...values, object_status: 0 };
    await onSave(values);
  };

  let onFinish = async (values, action = null) => {
    if (error.length) return false;
    saveAndNext = '';
    if (!!action) {
      saveAndNext = action;
    }
    await confirmationModal(values, 'Status', 'Is this record complete or incomplete?', 'Incomplete', 'Complete', complete, incomplete);
  };

  let onSave = async values => {
    if (error.length) return false;
    setLoading(true);
    const formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (!!value && !!value.fileList && value.fileList.length > 0) {
        formData.append(key, value.fileList[0].originFileObj);
      } else {
        key === 'mounting_method' && formData.append('mounting_method', value);
        // key === "photo_unmounted" && formData.append("photo_unmounted", value);
        // key === "photo_flush_mounted" &&
        //   formData.append("photo_flush_mounted", value);
        key === 'object_status' && formData.append('object_status', value);
      }
    });
    dispatch(userActions.saveFileItem('micro_meter/micrometer', formData, props.print, microData))
      .then(
        response => {
          setLoading(false);
          if (response) {
            formRef.current.resetFields('');
            formRef.current.setFieldsValue(response.data);
            setMicroData(response.data);
            notification['success']({
              message: 'Micrometer saved successfully!',
              duration: 2,
            });
            props.mountingUpdateState(' ');
            if (saveAndNext == '') {
              setTimeout(() => props.history.push('/print-objects', 1500));
            } else if (saveAndNext == 'next') {
              props.onChange('', 'glossmeter', title, 'Edit Micrometer');
            }
          }
        },
        errorReponse => {
          setLoading(false);
          if (!!errorReponse.errors) {
            Object.entries(errorReponse.errors).map(function (value, index) {
              value[0] === 'common_error' && message.error(value[1]);
              formRef.current.setFields([
                {
                  name: value[0],
                  errors: [value[1]],
                },
              ]);
            });
          } else {
            setLoading(false);
            unexpectedError();
          }
        }
      )
      .catch(error => {
        setLoading(false);
        unexpectedError(error);
      });
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    props.onChange('', 'xrf', 'XRF');
  };
  let fileChange = ({ file, fileList: newFileList }, fieldName) => {
    try {
      error = [];
      const correctFileNames = [`${printData.acquisition}.${fieldName}.xls`, `${printData.acquisition}.${fieldName}.xlsx`];
      if (!(file instanceof File)) return;
      const fileNameLower = file.name.toLowerCase();
      if (!correctFileNames.some(name => name.toLowerCase() === fileNameLower)) {
        error.push(`Please upload a file with the name ${correctFileNames.join(' or ')}`);
      } else {
        setFilesState(prevState => ({
          ...prevState,
          [fieldName]: newFileList,
        }));
      }
      formRef.current.setFields([
        {
          name: fieldName,
          errors: error.length ? error : '',
        },
      ]);
    } catch (error) {
      console.log(error);
    }
  };
  const onRemove = (file, fieldName) => {
    formRef.current.setFields([
      {
        name: fieldName,
        errors: '',
      },
    ]);
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  };

  const handleSaveAndNext = action => {
    formRef.current.validateFields().then(values => {
      onFinish(values, action);
    });
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="white-paper">
          <Row
            style={{
              backgroundColor: '#f5f5f5',
              border: '1px solid #0000000f',
              borderRadius: '7px',
              padding: '12px',
            }}
          >
            <Col md={8}>
              <div>Collection</div>
              <Typography.Title level={4} style={{ margin: 0 }}>
                <div style={{ fontSize: '19px' }}>{printData.name}</div>
              </Typography.Title>
            </Col>
            <Col md={8}>
              <div>Collection Acquisition ID</div>
              <Typography.Title level={4} style={{ margin: 0 }}>
                <div style={{ fontSize: '19px' }}>{printData.acquisition}</div>
              </Typography.Title>
            </Col>
            <Col md={8}>
              <div>Collection Title</div>
              <Typography.Title level={4} style={{ margin: 0 }}>
                <div style={{ fontSize: '19px' }}>{printData.title}</div>
              </Typography.Title>
            </Col>
          </Row>
          {/* Tabs start here */}
          <div className="artist" style={{ marginTop: '20px' }}>
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
              encType="multipart/form-data"
            >
              {/* <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item name="photo_unmounted" valuePropName="checked">
                      <Checkbox>Photo is unmounted</Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="photo_flush_mounted"
                      valuePropName="checked"
                    >
                      <Checkbox>Photo is flush mounted</Checkbox>
                    </Form.Item>
                  </Col>
                </Row> */}
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="mounting_method" label="Mounting Method">
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toString().toLowerCase().includes(input.toLowerCase())}
                      placeholder="Select a mounting method"
                      style={{ textTransform: 'capitalize' }}
                    >
                      {mountingData.map(el => (
                        <Select.Option key={el.id} value={el.id}>
                          {el.methods}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="photo"
                    label={
                      <div>
                        Photo
                        <UploadedCheck uploaded={microData?.photo} />
                      </div>
                    }
                  >
                    <Upload
                      name="file"
                      fileList={filesState.photo}
                      className="create_object"
                      accept={config.FileType.onlyXls.toString()}
                      beforeUpload={file => {
                        return beforeUpload(file, 'onlyXls', `${printData.acquisition}.photo`);
                      }}
                      onRemove={e => onRemove(e, 'photo')}
                      multiple={false}
                      maxCount={1}
                      onChange={e => fileChange(e, 'photo')}
                      showUploadList={showFilesList(microData?.photo, 'photo')}
                    >
                      <UploadTrigger fileType="onlyXls" />
                    </Upload>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="mount"
                    label={
                      <div>
                        Mount
                        <UploadedCheck uploaded={microData?.mount} />
                      </div>
                    }
                  >
                    <Upload
                      name="file"
                      fileList={filesState.mount}
                      className="create_object"
                      accept={config.FileType.onlyXls.toString()}
                      beforeUpload={file => {
                        return beforeUpload(file, 'onlyXls', `${printData.acquisition}.mount`);
                      }}
                      onRemove={e => onRemove(e, 'mount')}
                      multiple={false}
                      maxCount={1}
                      onChange={e => fileChange(e, 'mount')}
                      showUploadList={showFilesList(microData?.mount, 'mount')}
                    >
                      <UploadTrigger fileType="onlyXls" />
                    </Upload>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="bag"
                    label={
                      <div>
                        Bag
                        <UploadedCheck uploaded={microData?.bag} />
                      </div>
                    }
                  >
                    <Upload
                      name="file"
                      fileList={filesState.bag}
                      className="create_object"
                      accept={config.FileType.onlyXls.toString()}
                      beforeUpload={file => {
                        return beforeUpload(file, 'onlyXls', `${printData.acquisition}.bag`);
                      }}
                      onRemove={e => onRemove(e, 'bag')}
                      multiple={false}
                      maxCount={1}
                      onChange={e => fileChange(e, 'bag')}
                      showUploadList={showFilesList(microData?.bag, 'bag')}
                    >
                      <UploadTrigger fileType="onlyXls" />
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={backButton}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton()}
                {props.showButton() != '' ? (
                  <Button className="save-btn" type="primary" style={{ margin: '0 8px' }} onClick={() => handleSaveAndNext('next')}>
                    Save and Next
                  </Button>
                ) : (
                  ''
                )}
              </Form.Item>
            </Form>
          </div>
          {/* Tabs End here */}
        </Col>
      </Row>
    </Spin>
  );
};
export default MicroMeter;
